import { useState } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import { ClockCounterClockwise } from "@phosphor-icons/react";
import { useApi } from "@/lib/api";

const CATS = [["", "All"], ["scenarios", "Scenarios"], ["targets", "Targets"], ["settings", "Settings"]];
const when = (iso) => new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export const ActivityFeed = () => {
  const api = useApi();
  const [cat, setCat] = useState("");
  const q = useInfiniteQuery({
    queryKey: ["activity", cat],
    queryFn: ({ pageParam }) => api.get(`/activity?limit=30${cat ? `&category=${cat}` : ""}${pageParam ? `&before=${encodeURIComponent(pageParam)}` : ""}`),
    initialPageParam: null,
    getNextPageParam: (last) => (last.more ? last.items[last.items.length - 1].at : undefined),
    refetchInterval: 60000,
  });
  const items = q.data?.pages.flatMap((p) => p.items) || [];
  return (
    <section data-testid="activity-feed" className="rounded-xl border border-[#2A2A2A] bg-[#121212] p-6">
      <h2 className="font-display text-lg flex items-center gap-2"><ClockCounterClockwise className="text-[#00FF9D]" /> Team activity</h2>
      <p className="mt-1 text-xs text-[#6B6B6B]">Who changed which scenario, target or setting. Kept for 12 months.</p>
      <div data-testid="activity-filters" className="mt-4 flex flex-wrap gap-2">
        {CATS.map(([v, label]) => (
          <button key={v || "all"} data-testid={`activity-filter-${v || "all"}`} aria-pressed={cat === v} onClick={() => setCat(v)}
            className={`rounded-full border px-3 py-1 text-xs transition-colors ${cat === v ? "border-[#00FF9D] bg-[#00FF9D]/10 text-[#00FF9D]" : "border-[#2A2A2A] text-[#A3A3A3] hover:border-white hover:text-white"}`}>{label}</button>
        ))}
      </div>
      <div className="mt-2 divide-y divide-[#2A2A2A]">
        {q.isSuccess && items.length === 0 && <p data-testid="activity-empty" className="py-3 text-sm text-[#6B6B6B]">{cat ? "Nothing in this category yet." : "Nothing yet. Changes to scenarios, targets and settings will show up here."}</p>}
        {items.map((a, i) => (
          <div key={`${a.at}-${i}`} data-testid={`activity-item-${i}`} className="py-3 text-sm">
            <p><span className="text-white">{a.you ? "You" : a.actor_email}</span> <span className="text-[#A3A3A3]">{a.action}</span></p>
            {a.detail && <p className="mt-0.5 text-xs text-[#A3A3A3] break-words">{a.detail}</p>}
            <p className="mt-0.5 font-mono text-[11px] text-[#6B6B6B]">{when(a.at)}</p>
          </div>
        ))}
      </div>
      {q.hasNextPage && (
        <button data-testid="activity-load-more" onClick={() => q.fetchNextPage()} disabled={q.isFetchingNextPage}
          className="mt-3 rounded-full border border-[#2A2A2A] px-4 py-2 text-xs hover:border-white transition-colors disabled:opacity-50">{q.isFetchingNextPage ? "Loading…" : "Show older"}</button>
      )}
    </section>
  );
};
